import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ReactNode } from "react";

type Props = {
  title: string;
  value: string;
  score: string;
  scoreComment: string;
  icon: IconProp;
  children?: ReactNode;
};

export const ScoreCardBlock = ({
  icon,
  title,
  value,
  score,
  scoreComment,
  children,
}: Props) => {
  return (
    <div className="rounded-lg border border-monochrome-200 p-2 bg-white">
      <div className="flex justify-between gap-3">
        <div className="grid grid-cols-[16px_1fr] gap-x-2">
          <FontAwesomeIcon
            icon={icon}
            className="text-monochrome-600 text-md"
          />
          <p className="typography-body-xs text-monochrome-600">{title}</p>
          <div />
          <p className="typography-body-xs">{value}</p>
        </div>
        <div>
          <p className="typography-body-bold-sm text-end">{score}</p>
          <p className="typography-body-xs text-green-600 text-end">
            {scoreComment}
          </p>
        </div>
      </div>
      {children}
    </div>
  );
};
